// TK-13315 — brand logo hover overlay for Boost product cards.
// Shows the brand's logo bottom-centre of the VISIBLE product image, only while the image is hovered.
// Data: window.DW_BRAND_MAP (from dw-brand-map.js) — { "<Vendor>": "<asset file>" }.
// Unconfirmed vendors fall back to the DW logo. Private-label lines are already mapped to
// customer-safe logos, so no real vendor name is ever rendered.
// window.DW_BRAND_BASE = theme assets folder URL (set by snippets/dw-grid-logo.liquid).
(function () {
  var MAP = window.DW_BRAND_MAP || {};
  var BASE = window.DW_BRAND_BASE || '';
  var FALLBACK = MAP['__fallback__'];
  var NO_HOVER = !!(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
  var PLACERS = [];
  if (NO_HOVER) {
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { PLACERS.forEach(function (p) { p(); }); }, 150);
    });
  }

  // Boost card alt text is "<Pattern>, <Collection> | <Vendor>". Only the vendor after the
  // last "|" identifies the brand; matching the whole string would let a pattern name such
  // as "Malibu Sunset" pull in the Malibu logo.
  // Use the first image whose alt carries the "| Vendor" suffix, in case a card's first image
  // has no vendor alt.
  function logoFor(card) {
    var imgs = card.querySelectorAll('.boost-sd__product-image-img');
    var alt = '';
    for (var i = 0; i < imgs.length; i++) {
      if ((imgs[i].alt || '').indexOf('|') !== -1) { alt = imgs[i].alt; break; }
    }
    if (alt.indexOf('|') === -1) return FALLBACK;
    var vendor = alt.split('|').pop().trim();
    return Object.prototype.hasOwnProperty.call(MAP, vendor) ? MAP[vendor] : FALLBACK;
  }

  // The image box can be taller/wider than the picture (object-fit: contain letterbox), so
  // measure where the picture actually ends and sit the logo 12px above that edge.
  function imageBottomGap(wrap) {
    var imgs = wrap.querySelectorAll('.boost-sd__product-image-img');
    var w = wrap.getBoundingClientRect();
    var best = null;
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (!im.naturalWidth || getComputedStyle(im).visibility === 'hidden') continue;
      var r = im.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      var bottom = r.bottom;
      var fit = getComputedStyle(im).objectFit;
      if (fit === 'contain' || fit === 'scale-down') {
        var scale = Math.min(r.width / im.naturalWidth, r.height / im.naturalHeight);
        if (fit === 'scale-down') scale = Math.min(scale, 1);
        bottom = r.top + (r.height + im.naturalHeight * scale) / 2;
      }
      if (best === null || bottom > best) best = bottom;
    }
    if (best === null) return 12;
    return Math.max(12, Math.round(w.bottom - Math.min(best, w.bottom) + 12));
  }

  function decorate(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.boost-sd__product-image-wrapper').forEach(function (wrap) {
      if (wrap.querySelector('.dw-brand-overlay')) return;
      var card = wrap.closest('.boost-sd__product-item') || wrap;
      var file = logoFor(card);
      if (!file) return;
      var el = document.createElement('div');
      el.className = 'dw-brand-overlay';
      el.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img');
      im.src = BASE + file;
      im.alt = '';
      im.loading = 'lazy';
      el.appendChild(im);
      wrap.appendChild(el);
      function place() { el.style.bottom = imageBottomGap(wrap) + 'px'; }
      wrap.addEventListener('mouseenter', place);
      // TK-13722: touch has no mouseenter and the logo is always visible, so position it as soon as the
      // picture is measurable (each image load) and again on resize/rotate.
      if (NO_HOVER) {
        wrap.querySelectorAll('.boost-sd__product-image-img').forEach(function (i) {
          if (i.complete) place(); else i.addEventListener('load', place, { once: true });
        });
        place();
        PLACERS.push(place);
      }
    });
  }

  function start() {
    decorate(document);
    // Boost re-renders the grid on infinite scroll / filter changes.
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) decorate(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
